export const appConfig = {
  sentryDsn: '',
  ipstackAccessKey: 'fc6527e9ae98bb87ffcca52e0f6155c7',
  clientCryptoKey: 'I@MTHEVC0MPLYUSER',
}
